module.exports = __webpack_public_path__ + "static/champion-found-a381fb07d9cabe12485d80d0fda31a0f.png";